export default {
    assessments: '9b542ac12000b5422',
};